var sliderInfFeatSecLar = tns({
    "container": ".slider-sliderInfFeatSecLar",
    "controlsContainer": ".slider-sliderInfFeatSecLar-controls",
    "preventScrollOnTouch": "force",
    "controlsPosition": "bottom",
    "controls": false,
    "navPosition": "bottom",
    "mouseDrag": true,
    "speed": 400,
    "fixedWidth": 288,
    "gutter": 32,
    "center": true,
    "autoheight": true,
    "nav":false,
    "responsive": {
        "576": {
            "autoheight": true,
            "center": true,
            "items": 1,
            "swipeAngle": false,
            "nav": false
        },
        "768": {
            "items": 1,
            "slideBy": 1,
            "center": false,
            "nav": true
        },
        "1280": {
            "controls": true,
            "fixedWidth": 664,
            "center": true,
            "nav": true
        }
    }
});

var sliderLeadershipTeam = tns({
    "container": ".slider-leadership-team",
    "controlsContainer": ".slider-leadership-team-controls",
    "preventScrollOnTouch": "force",
    "controlsPosition": "bottom",
    "controls": false,
    "navPosition": "bottom",
    "mouseDrag": true,
    "speed": 400,
    "fixedWidth": 264,
    "gutter": 32,
    "center": true,
    "responsive": {
        "576": {
            "center": true
        },
        "768": {
            "items": 3,
            "slideBy": 3,
            "center": true
        },
        "1280": {
            "controls": true,
            "center": true
        }
    }
});


